import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=bf9cc8a0&"
import script from "./plan.ts?vue&type=script&lang=ts&"
export * from "./plan.ts?vue&type=script&lang=ts&"
import style0 from "./plan.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports